// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  /* overflow-x: hidden; */
}

.footer {
  background-color: #c1c1c1;
  padding: 15px;

  font-size: 18px;
  font-weight: 600;
  color: black;
  z-index: 1;
  /* Add this line */
}

.footer-content {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  /* max-width: max-content; */
  margin: 0 auto;
}

.footer-logos {
  display: flex;
  align-items: center;
  padding-left: 25px;
  justify-content: space-between;
  background-color: #c1c1c100;
}

/* custom for the images on the left */
.athlCan {
  background-color: rgba(255, 255, 255, 0);
}

.swim-voll {}

.footer-logos img {
  min-height: 80px;
  max-height: 100px;
  /* margin-right: 10px;
  margin-bottom: -15px; */
}

.footer-logo {
  /* Center the main logo */
  text-align: center;
}

.footer-logo img {
  max-height: 90px;
}

.footer-contact {
  text-align: right;
  padding-top: 25px;
}

/* Optional: Style the contact info */
.footer-contact p {
  margin: 0;
  padding-right: 25px;

}

.footer-logos a {
  text-decoration: none;
  /* Remove default underline for links */
}

.footer-logos img {
  max-height: 60px;
  /* margin-right: 10px; */
  transition: transform 0.3s ease-in-out;
  /* Add smooth transition for hover effect */
}

.footer-logos a:hover img {
  transform: scale(1.1);
  /* Increase size on hover */
}

.vertical-line {
  width: 1px;
  height: 80px;
  background-color: black;
  margin: 0 10px;
}



@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
  }

  .footer {
    width: 100%;

  }

  .footer-logo,
  .footer-logos,
  .footer-contact {
    text-align: center;
  }

  .footer-logo img,
  .footer-logos img {
    max-height: 60px;
  }

  .footer-contact {

    padding-bottom: 15px;
  }

  .footer-logos img {
    min-height: 60px;
    max-height: 60px;
    margin-bottom: 10px;
  }

  .footer-contact p {
    margin: 0;
    padding-bottom: 0px;
  }

  .footer-logos {
    display: flex;
    align-items: center;
    padding-left: 0px;
  }
}

@media (max-width: 425px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
  }

  .footer {
    width: 100%;

  }

  .footer-logo,
  .footer-logos,
  .footer-contact {
    text-align: center;
  }

  .footer-logo img,
  .footer-logos img {
    max-height: 60px;
  }

  .footer-contact {

    padding-bottom: 5px;

  }

  .footer-logos img {
    min-height: 60px;
    max-height: 60px;
    margin-bottom: 10px;
  }

  .footer-contact p {
    margin: 0;
    padding-right: 0px;
  }

  .footer-logos {
    display: flex;
    align-items: center;
    padding-left: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,aAAa;;EAEb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,wCAAwC;AAC1C;;AAEA,YAAY;;AAEZ;EACE,gBAAgB;EAChB,iBAAiB;EACjB;yBACuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,SAAS;EACT,mBAAmB;;AAErB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;;;AAIA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;;EAEb;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;;EAEb;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;;EAErB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  /* overflow-x: hidden; */\n}\n\n.footer {\n  background-color: #c1c1c1;\n  padding: 15px;\n\n  font-size: 18px;\n  font-weight: 600;\n  color: black;\n  z-index: 1;\n  /* Add this line */\n}\n\n.footer-content {\n  display: flex;\n  justify-content: space-between;\n  /* align-items: center; */\n  /* max-width: max-content; */\n  margin: 0 auto;\n}\n\n.footer-logos {\n  display: flex;\n  align-items: center;\n  padding-left: 25px;\n  justify-content: space-between;\n  background-color: #c1c1c100;\n}\n\n/* custom for the images on the left */\n.athlCan {\n  background-color: rgba(255, 255, 255, 0);\n}\n\n.swim-voll {}\n\n.footer-logos img {\n  min-height: 80px;\n  max-height: 100px;\n  /* margin-right: 10px;\n  margin-bottom: -15px; */\n}\n\n.footer-logo {\n  /* Center the main logo */\n  text-align: center;\n}\n\n.footer-logo img {\n  max-height: 90px;\n}\n\n.footer-contact {\n  text-align: right;\n  padding-top: 25px;\n}\n\n/* Optional: Style the contact info */\n.footer-contact p {\n  margin: 0;\n  padding-right: 25px;\n\n}\n\n.footer-logos a {\n  text-decoration: none;\n  /* Remove default underline for links */\n}\n\n.footer-logos img {\n  max-height: 60px;\n  /* margin-right: 10px; */\n  transition: transform 0.3s ease-in-out;\n  /* Add smooth transition for hover effect */\n}\n\n.footer-logos a:hover img {\n  transform: scale(1.1);\n  /* Increase size on hover */\n}\n\n.vertical-line {\n  width: 1px;\n  height: 80px;\n  background-color: black;\n  margin: 0 10px;\n}\n\n\n\n@media (max-width: 768px) {\n  .footer-content {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .footer {\n    width: 100%;\n\n  }\n\n  .footer-logo,\n  .footer-logos,\n  .footer-contact {\n    text-align: center;\n  }\n\n  .footer-logo img,\n  .footer-logos img {\n    max-height: 60px;\n  }\n\n  .footer-contact {\n\n    padding-bottom: 15px;\n  }\n\n  .footer-logos img {\n    min-height: 60px;\n    max-height: 60px;\n    margin-bottom: 10px;\n  }\n\n  .footer-contact p {\n    margin: 0;\n    padding-bottom: 0px;\n  }\n\n  .footer-logos {\n    display: flex;\n    align-items: center;\n    padding-left: 0px;\n  }\n}\n\n@media (max-width: 425px) {\n  .footer-content {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .footer {\n    width: 100%;\n\n  }\n\n  .footer-logo,\n  .footer-logos,\n  .footer-contact {\n    text-align: center;\n  }\n\n  .footer-logo img,\n  .footer-logos img {\n    max-height: 60px;\n  }\n\n  .footer-contact {\n\n    padding-bottom: 5px;\n\n  }\n\n  .footer-logos img {\n    min-height: 60px;\n    max-height: 60px;\n    margin-bottom: 10px;\n  }\n\n  .footer-contact p {\n    margin: 0;\n    padding-right: 0px;\n  }\n\n  .footer-logos {\n    display: flex;\n    align-items: center;\n    padding-left: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
